import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { FeatureFlagProvider } from "./lib/unleash/FeatureFlagProvider.tsx";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <FeatureFlagProvider>
        <App />
      </FeatureFlagProvider>
    </HelmetProvider>
  </React.StrictMode>
);
